import { accessPointEvents, apClusterMarker } from './apFeatures';
import {
  linkEvents,
  ptpLinkClusterMarker,
  pmpLinkClusterMarker,
} from './linkFeatures';
import {
  siteFeatureEvents,
  networkSiteMarker,
  subscriberSiteMarker,
} from './siteFeatures';
import getFeatureStyle from './getFeatureStyle';

/**
 * Return the appropriate Leaflet GeoJSON for the feature kind.
 *
 * The resulting object can be passed when an new L.geoJSON
 * instance is created, e.g.
 *
 * new L.geoJSON(featureCollection, getLayer("network_site"));
 *
 * @param {String} kind - The object kind.
 *                        "network_site", "subscriber_site", "access_point",
 *                        "ptp_link" and "pmp_link" are currently supported.
 */

const getGeoJsonLayerOptions = (kind) => {
  return {
    network_site: {
      onEachFeature: siteFeatureEvents,
      pointToLayer: networkSiteMarker,
    },
    subscriber_site: {
      onEachFeature: siteFeatureEvents,
      pointToLayer: subscriberSiteMarker,
    },
    access_point: {
      onEachFeature: accessPointEvents,
      style: getFeatureStyle,
      pointToLayer: apClusterMarker,
      filter: (feature) => {
        if (window.location.pathname === '/channel_60ghz') {
          return feature.properties.radios[0].band === '60 GHz';
        }
        return true;
      },
    },
    ptp_link: {
      onEachFeature: linkEvents,
      style: getFeatureStyle,
      pointToLayer: ptpLinkClusterMarker,
    },
    mesh_link: {
      onEachFeature: linkEvents,
      style: getFeatureStyle,
      pointToLayer: ptpLinkClusterMarker,
    },
    pmp_link: {
      onEachFeature: linkEvents,
      style: getFeatureStyle,
      pointToLayer: pmpLinkClusterMarker,
    },
  }[kind];
};

export default getGeoJsonLayerOptions;
